import Shinkeisuijaku from "./special/special_shinkeisuijaku/game.es6";
import { SELECTOR } from "./special/special_shinkeisuijaku/config.es6";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SELECTOR.root).forEach((root) => new Shinkeisuijaku(root));
});
